<template>
  <div class="tooltip-wrapper">
    <slot ref="activator" name="activator" :on="events">
      <i v-on="events" class="icon-info"></i>
    </slot>
    <transition name="fade" tag="div">
      <div class="tooltip-body" :class="[show ? 'visible' : '', tooltipPosition]" :style="styles" ref="body">
        <slot name="default" />
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    color: {
      type: String,
      default: () => '#ffffff',
    },
    background: {
      type: String,
      default: () => '#000000',
    },
    position: {
      validator: (val) => ['top', 'bottom', 'left', 'right', 'default'].includes(val),
      default: () => 'default',
    },
    denseX: {
      type: Number,
      default: () => 20,
    },
    denseY: {
      type: Number,
      default: () => 10,
    },
  },
  watch: {
    value(val) {
      this.show = val;
    },
  },
  data: () => ({
    show: false,
    events: Object(),
    absoluteStyles: Object(),
    tooltipCalculatedPos: '',
  }),
  computed: {
    styles() {
      return {
        backgroundColor: this.background,
        color: this.color,
        border: `2px solid ${this.color}`,
        ...this.absoluteStyles,
      };
    },
    tooltipPosition() {
      return this.position !== 'default' ? this.position : this.tooltipCalculatedPos;
    },
  },
  methods: {
    getPositiontop(tip, parent) {
      return {
        top: -tip.height - this.denseY + 'px',
        left: (parent.width - tip.width) / 2 + 'px',
      };
    },
    getPositionbottom(tip, parent) {
      return {
        bottom: -tip.height - this.denseY + 'px',
        left: (parent.width - tip.width) / 2 + 'px',
      };
    },
    getPositionleft(tip, parent) {
      return {
        right: this.denseX + 'px',
        top: (parent.height - tip.height) / 2 + 'px',
      };
    },
    getPositionright(tip, parent) {
      return {
        left: this.denseX + 'px',
        top: (parent.height - tip.height) / 2 + 'px',
      };
    },
    getPositionStyle() {
      const tooltipPos = this.$refs.body.getBoundingClientRect();
      const parentPos = this.$el.getBoundingClientRect();
      const win = {
        w: window.innerWidth,
        h: window.innerHeight,
      };
      if (this.position !== 'default') {
        this.absoluteStyles = { ...this[`getPosition${this.position}`](tooltipPos, parentPos) };
      } else {
        if (win.h - tooltipPos.top - tooltipPos.height - this.denseY > 0) {
          this.absoluteStyles = { ...this.getPositiontop(tooltipPos, parentPos) };
          this.tooltipCalculatedPos = 'top';
          return;
        }
        this.absoluteStyles = { ...this.getPositionbottom(tooltipPos, parentPos) };
        this.tooltipCalculatedPos = 'bottom';
      }
    },
    processShow() {
      this.getPositionStyle();
      this.show = true;
    },
  },
  created() {
    const eventObj = Object();
    eventObj.mouseenter = () => {
      this.processShow();
    };
    eventObj.mouseleave = () => {
      this.show = false;
    };
    this.events = { ...eventObj };
  },
});
</script>

<style lang="scss" scoped>
  .icon-info {
    width: 16px;
    height: 16px;
    background-image: url('/img/icons/icon_info.svg');
    background-size: contain;
    display: inline-block;
    filter: invert(1);
    cursor: pointer;
  }
  .tooltip-wrapper {
    display: inline-block;
    position: relative;
  }
  .tooltip-body {
    width: auto;
    height: auto;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    border: inherit;
    filter: opacity(0);
    transition: filter .2s linear;
    z-index: 40000;

    &::before{
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background: inherit;
      position: absolute;
      transform: rotate(45deg) translateY(3px);
      z-index: 39000;
      border-bottom: inherit;
      border-right: inherit;
    }

    &.top::before {
      left: calc(50% - 10px);
      bottom: -10px;
    }

    &.bottom::before {
      left: calc(50% - 10px);
      top: -10px;
    }

    &.left::before {
      right: -10px;
      top: calc(50% - 10px);
    }

    &.right::before {
      left: -10px;
      top: calc(50% - 10px);
    }

    &.visible {
      filter: opacity(1);
    }
  }
</style>
